import React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { CommentsCommentFragment } from 'generated/resources/graphql'

import { ReactionsReactionValues } from 'modules/core/components/Reactions/Reaction'
import { MentionedAccess } from 'modules/core/components/TextEditor/plugins/DebouncedMentionsPlugin'
import { Result, UnhandledResult } from 'modules/core/lib/handleMutation'

import CommentsContainer from 'modules/comments/components/CommentsContainer'
import { CommentsCommentValues } from 'modules/comments/components/CommentsContainer/CommentEditor'

interface Props {
  loading: boolean
  previousComments?: CommentsCommentFragment[]
  comments: CommentsCommentFragment[]
  totalCount: number
  onShowMore: () => void
  onAddComment: (
    variables: CommentsCommentValues
  ) => Promise<UnhandledResult<Result<Omit<unknown, 'errors'>>>>
  resourceId: number
  onFetchCustomMentionableAccesses?: (queryString: string) => Promise<MentionedAccess[]> | undefined
  onAddReaction?: (
    variables: ReactionsReactionValues,
    parentResourceId: number
  ) => Promise<{ id: number } | undefined>
  onDeleteReaction?: (
    id: number,
    parentResourceId: number,
    resourceId: number,
    textCode: string
  ) => Promise<{ success: boolean } | undefined>
}

const PageComments = ({
  loading,
  previousComments,
  comments,
  onShowMore,
  totalCount,
  resourceId,
  onAddComment,
  onFetchCustomMentionableAccesses,
  onAddReaction,
  onDeleteReaction,
}: Props) => {
  if (loading) {
    return (
      <Box
        background="grey100"
        borderRadius={{ all: 'abs012' }}
        justifyContent="center"
        alignItems="center"
        height="s200"
      >
        <Spinner />
      </Box>
    )
  }

  return (
    <Box background="grey100" borderRadius={{ all: 'abs012' }}>
      <CommentsContainer
        type="firstAndLast"
        previousComments={previousComments}
        comments={comments}
        onShowMore={onShowMore}
        totalCount={totalCount}
        onAddComment={onAddComment}
        resourceId={resourceId}
        onFetchCustomMentionableAccesses={onFetchCustomMentionableAccesses}
        onAddReaction={onAddReaction}
        onDeleteReaction={onDeleteReaction}
      />
    </Box>
  )
}

export default PageComments
